import store from "@store/index"
import _, { unset } from "lodash"
import Vue from 'vue'

// state
const state = {
    init: true,
    auth: false,
    uuid: null,
    form: {},
    sections: {},
    rows: {},
    answers: {},
    settings: {},
    displayErrors: false,
    achieved: false,
    options: [],
    customFieldsValidations: {},
    stop: {
        section: null,
        row: null
    }
}

// getters
const getters = {


    matchCondition: (state) => (condition) => {

        var row = condition.form_row ? condition.form_row : {}
        var answer = _.get(state.answers, row.key)

        var operator = condition.condition_operator
        var value = condition.condition_value
        

        if(row.type == 'place')
        {
            answer = _.get(answer, 'address', null);
        }

        // Clean answer from empty values
        answer = _.isArray(answer) ? _.filter(answer) : answer;


        if(condition.exact_match)
        {  
            answer = _.isArray(answer)
            ? _.map(answer, item => {
                return _.kebabCase(item)
            }) : _.kebabCase(answer)

            value = _.map(value, v => {
                return _.kebabCase(v)
            })
        }
        

        switch(operator)
        {
            case "=":
                return _.isArray(answer) 
                ? _.intersection(answer, value).length == value.length
                && value.length == answer.length
                : answer == value[0];
                break;

            case "!=":
                return _.isArray(answer) 
                ? _.intersection(answer, value).length == 0
                : answer && answer != value[0];
                break;

            case "in":
                return _.isArray(answer)
                ? _.intersection(answer, value).length
                : value.includes(answer)
                break;
        }

    },

    matchConditions: (state, getters) => (item) => {

        if(!item) {
            return false;
        }

        var groups = _.groupBy(item.conditions, 'group')
        var visible = false

        if(!_.keys(groups).length)
        {
            return true
        }

        _.forEach(groups, (group, i) => {

            var has_group = false;
            var check = [];

            group.forEach(condition => {
                check.push(getters.matchCondition(condition) ? 1 : 0)
            })

            if(_.sum(check) == check.length) 
            {
                visible = true;
                return false;
            }


        })

        // Visible and not set as stop yet ? Then set it to stop
        if(visible && _.get(item, 'type') == 'stop' && !state.stop.row)
        {
            store.dispatch('form/setStop', {
                row: item.id,
                section: item.parentable_type == 'formSection' ? item.parentable_id : null
            })
        }

        return visible

    },

    isProgressable: (state, getters) => (row) => {
        return !['content', 'stop', 'alert', 'dynamic'].includes(row.type)
    },

    isVisible: (state, getters) => (item) => {

        var visible = getters.matchConditions(item)

        if(!item) {
            return false;
        }

        // Is it a row ?
        if(item.type) {

            if(item.type == 'dynamic')
            {
                return false;
            }

            if(!visible && state.answers[item.key])
            {
                store.dispatch('form/unsetAnswer', item.key)
            }

            var index = _.findIndex(state.rows, o => {
                return o.id == item.id; 
            })

            return state.stop.row 
            ? visible && index <= state.stop.row
            : visible
        }

        // Is it a section ?
        if(!item.type) {

            var index = _.findIndex(state.sections, o => {
                return o.id == item.id; 
            })

            if(!visible)
            {
                _.map(item.rows, row => {
                    if(state.answers[row.key])
                    {
                        store.dispatch('form/unsetAnswer', row.key)
                    }
                })
            }

            return state.stop.section 
            ? visible && index <= state.stop.section
            : visible

        }

    },

    rows(state, getters) {
        return _.filter(state.rows, row => {
            return row.parentable_type == 'form'
            && getters.isVisible(row)
        })
    },
    
    sections(state, getters) {
        return _.filter(state.sections, section => {
            return section.parentable_type == 'form'
            && getters.isVisible(section)
        })
    },

    answers(state, getters) {
        return _.mapValues(state.answers, (answer, key) => {

            var row = _.find(state.rows, row => {
                return row.key == key && getters.isVisible(row)
            })

            if(!row) {
                return;
            }

            if(['checkbox', 'select', 'radio'].includes(row.type))
            {
                var answers = App.$trans(row.value)

                return _.isArray(answer)
                ? _.map(answer, a => answers[a])
                : answers[answer]
            }

            if(['grid-checkbox', 'grid-radio'].includes(row.type))
            {
                var columns = App.$trans(row.value).columns
                var rows = App.$trans(row.value).rows
                var output = {}

                _.map(answer, (value, key) => {

                    output[rows[key]] = _.map(value, c => {
                        return columns[c]
                    })

                })

                return output

            }
            
            return answer

        })
    },

    stop(state) {
        return state.stop.row ? true : false
    },

    checkAnswer: (state, getters) => (row, answer) => {

        var check = "Ce champs est requis"
        var rules = row.display_rules

        if(!rules.required || row.type == 'custom')
        {
            return true;
        }

        if(!answer) {
            return check
        }

        if(_.isString(answer) || _.isBoolean(answer)) 
        {
            if(answer) {
               check = true
            }

            if(rules.email) {
                check = answer.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/) 
                ? true 
                : "Email invalide";
            }

            return check
        }

        if(_.isArray(answer)) 
        {
            if(answer.length) {
                return true
            }
        }

        if(_.isObject(answer)) 
        {
            if(Object.values(answer).length) {
                return true
            }
        }

    },

    countProgress: (state, getters) => (rows) => {

        var count = 0;
        var total = 0;
        var errors = {}

        _.map(rows, row => {

            if(getters.isVisible(row) && getters.isProgressable(row))
            {
                var answer = _.get(getters.answers, row.key)
                var check = getters.checkAnswer(row, answer)
                
                if(_.isBoolean(check) && check)
                {
                    count += row.type == 'custom'
                    ? _.get(state.customFieldsValidations[row.key], 'count', 1)
                    : 1
                }
                else
                {
                    if(_.isString(check))
                    {
                        errors[row.key] = check
                    }

                    if(row.type != 'custom' && !answer)
                    {
                        store.dispatch('form/unsetAnswer', row.key)
                    }
                }

                total += row.type == 'custom'
                ? _.get(state.customFieldsValidations[row.key], 'total', 1)
                : 1
            }

        })

        return {
            count: count,
            total: total,
            errors: errors
        }

    },

    progress(state, getters) {

        var sections = {}

        _.map(getters.sections, section => {

            var progress = getters.countProgress(section.rows)

            sections[section.id] = {
                count: progress.count,
                total: progress.total,
                errors: progress.errors,
                percentage: Math.ceil(progress.count * 100 / progress.total)
            }

        })

        var progress = getters.countProgress(state.rows)
        var count = progress.count + _.sum(_.map(sections, 'count'))
        var total = progress.total + _.sum(_.map(sections, 'total'))

        return {
            count: count,
            total: total,
            percentage: Math.ceil(count * 100 / total),
            sections: sections
        }

    }

}

// actions
const actions = {

    setUuid({state, commit}, uuid) {

        commit('setUuid', uuid)

        var url = new URL(window.location);
        url.searchParams.set('uuid', uuid);
        window.history.pushState({}, '', url);
    },

    saveForm({state, dispatch, getters, commit}) {

        return new Promise((resolve, reject) => {

            if(state.uuid) 
            {
                axios.post('/forms/formEntries/'+state.uuid, {
                    _method: 'PUT',
                    progress: getters.progress.percentage,
                    answers: state.answers
                })
                .then(response => { resolve(response.data) })
                .catch(error => { reject(error) })
            } 
            else
            {
                axios.post('/forms/formEntries', {
                    key: state.form.key,
                    progress: getters.progress.percentage,
                    answers: state.answers
                }).then(response => {
                    dispatch('setUuid', response.data.uuid)
                    resolve(response.data)
                })
                .catch(error => { reject(error) })
            }


        })

        

    },

    initForm({commit, dispatch}, id) {

        return new Promise((resolve, reject) => {

            var params = new URLSearchParams(window.location.search)
            
            axios.post('forms/'+id, {
                uuid: params.get('uuid')
            })
            .then(response => {

                var data = response.data
                        
                commit('setForm', data.form)
                commit('setAuth', data.auth)
                commit('setSettings', data.form.settings)
                commit('setSections', data.sections)
                commit('setRows', data.rows)
                commit('setUuid', data.uuid)
                commit('setAnswers', data.answers)
                dispatch('resetCustomFieldsValidations')

                if(data.status == 'achieved')
                {
                    commit('setAchieved', true)
                }

                if(!data.uuid)
                {
                    dispatch('setDefaultAnswers')
                }

                resolve(data)
            })
            .catch(error => {
                reject(error)
            })

        })

    },

    submitForm({commit, state, getters, dispatch}) {
        return new Promise((resolve, reject) => {
            
            axios.post('/forms/formEntries/submit', {
                uuid: state.uuid,
                key: state.form.key,
                progress: getters.progress.percentage,
                answers: state.answers
            })
            .then(response => {
                dispatch('setUuid', response.data)
                commit('setAchieved', true)
                resolve(response.data)
            })
            .catch(error => { reject(error) })
            
        })
    },

    setDefaultAnswers({state, commit}) {

        _.map(state.rows, row => {

            if(row.default_value)
            {
                var value = this._vm.$trans(row.default_value)

                if(_.isString(value)) {
                    value = value.replace('{year}', moment().format('Y'))
                }

                commit('setAnswer', {
                    key: row.key,
                    value: value
                })
            }

        })
        
    },

    resetCustomFieldsValidations({state, commit}) {
       
        _.map(_.filter(state.rows, r => r.type == 'custom'), row => {

            commit('setCustomFieldValidation', {
                key: row.key,
                value: { 
                    count: 0,
                    total: 1,
                    errors: {}
                }
            })

        })
        
    },

    setStop({state, commit}, payload) {

        var indexRow = _.findIndex(state.rows, o => {
            return o.id == payload.row; 
        });

        var indexSection = _.findIndex(state.sections, o => {
            return o.id == payload.section; 
        });

        commit('setStopRow', indexRow > 0 ? indexRow : 0)
        commit('setStopSection', indexSection > 0 ? indexSection : 0)
    },


    resetStop({dispatch}) {
        dispatch('setStop', {
            row: null,
            section: null
        })
    },


    unsetAnswer({commit, dispatch, state}, key) {
        
        if(_.has(state.answers, key)) 
        {
            delete state.answers[key]
            dispatch('resetStop')
        }
    },

    setAnswer({commit, dispatch}, payload) {
        dispatch('resetStop')
        commit('setAnswer', payload)
    }

}
 
// mutations
const mutations = {

    setForm(state, value) {
        state.form = value
    },

    setAuth(state, value) {
        state.auth = value
    },

    setUuid(state, value) {
        state.uuid = value
    },

    setSections(state, value) {
        state.sections = value
    },
    
    setRows(state, value) {
        state.rows = value
    },

    setAnswer(state, payload) {
        Vue.set(state.answers, payload.key, payload.value)
    },

    setAnswers(state, value) {
        state.answers = _.isArray(value) ? Object.fromEntries(value) : value
    },

    setSettings(state, value) {
        state.settings = value
    },

    setProgress(state, value) {
        state.progress = value
    },

    setAchieved(state, value) {
        state.achieved = value
    },

    setStopRow(state, value) {
        state.stop.row = value
    },

    setStopSection(state, value) {
        state.stop.section = value
    },

    setOptions(state, value) {
        state.options = value
    },

    setDisplayErrors(state, value) {
        state.displayErrors = value
    },

    setCustomFieldValidation(state, payload) {

         Vue.set(state.customFieldsValidations, payload.key, {
            count: payload.value.count,
            total: payload.value.total,
            errors: payload.value.errors
         })
    },

}


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}